import { render, staticRenderFns } from "./game_n.vue?vue&type=template&id=48b36dae&scoped=true&"
import script from "./game_n.vue?vue&type=script&lang=js&"
export * from "./game_n.vue?vue&type=script&lang=js&"
import style0 from "./game_n.vue?vue&type=style&index=0&id=48b36dae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b36dae",
  null
  
)

export default component.exports